import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
	GetProfilesQueueItem,
	getPersonGetProfilesQueue,
} from "../../api/person/get-profiles-queue";
import { formatDateTime } from "../../utils/date-formatting";
import { useGlobalState } from "../globalState";

interface PersonGetProfilesQueueProps {
	personId: number;
}

export const PersonGetProfilesQueue = ({ personId }: PersonGetProfilesQueueProps) => {
	const [items, setItems] = useState<GetProfilesQueueItem[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const { currentUser } = useGlobalState();

	useEffect(() => {
		if (!currentUser.is_superuser || !personId) {
			setLoading(false);
			return;
		}

		getPersonGetProfilesQueue(personId)
			.then((res) => setItems(res.results))
			.finally(() => setLoading(false));
	}, [personId, currentUser.is_superuser]);

	if (!currentUser.is_superuser || loading) {
		return null;
	}

	return (
		<Accordion
			defaultExpanded={false}
			data-component="get-profiles-queue-accordion"
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				data-component="accordion-summary"
			>
				<Typography variant="h6">GetProfilesQueue ({items.length})</Typography>
			</AccordionSummary>
			<AccordionDetails data-component="accordion-details">
				<TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
					<Table size="small" sx={{ minWidth: 600 }}>
						<TableHead>
							<TableRow>
								<TableCell>ID</TableCell>
								<TableCell>Created</TableCell>
								<TableCell>Type</TableCell>
								<TableCell>Priority</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{items.map((item) => (
								<TableRow key={item.id} data-component="queue-row">
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.id}
										</Typography>
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{formatDateTime(item.created)}
										</Typography>
									</TableCell>
									<TableCell>
										<Chip label={item.type} size="small" />
									</TableCell>
									<TableCell>
										<Typography variant="body2" noWrap>
											{item.priority}
										</Typography>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionDetails>
		</Accordion>
	);
};
